import {observable, action, runInAction} from 'mobx'
import {json, get, post} from '../../../../utils/ajax'
import {handleSeerchAndPage, objToValueObj, setStore, ValueObjToObj} from '../../../../utils/Utils'
import {message} from "antd";

class epcSparepartDefinationStore{
    @observable list//页面数据
    @observable loading//数据加载
    @observable searchFields//表单绑值
    @observable pagination//分页
    @observable selectedRowKeysId//获取勾选行的id
    @observable ExportModal  //导入模态框
    @observable modal //新增修改模态框
    @observable option //选择新增修改
    @observable forms
    @observable attributeModal //属性维护模态框
    @observable attributeForms //属性维护
    @observable importReturnData //导入返回值
    @observable showDrawer //导入抽屉

    constructor(){
        this.list=[]
        this.loading=false
        this.searchFields={
            materialNo: '',
            sparePartName: '',
            sparePartNo: '',
            definitionFalg: ''
        }
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper:true,
            showSizeChanger:true,
            pageSize:20,
            showTotal:()=>{}
        }
        this.selectedRowKeysId=[]
        this.ExportModal = false
        this.modal = false
        this.option = ''
        this.forms={}
        this.attributeForms={}
        this.attributeModal=false
    }

    /**
     * 将页面的值绑到store
     * @param changedFields
     */
    @action
    onSearchFieldChange=(changedFields)=>{
        this.searchFields = {...this.searchFields, ...ValueObjToObj(changedFields)}
    }

    /**
     * 设置store对象，类似react的setState
     * @param obj
     */
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**
     * 页面初始化
     * @param page
     * @returns {Promise<void>}
     */
    @action
    initPage = async (page) => {
        this.loading = true
        if(this.searchFields.definitionFalg===undefined){
            this.searchFields.definitionFalg=''
        }
        let search = handleSeerchAndPage(page, this.pagination, this.searchFields)
        search.size = this.pagination.pageSize
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/defination/queryList:search`, search)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.list = res.content || []
            this.loading = false
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper:true,
                showSizeChanger:true,
                pageSize:res.size,
                showTotal:()=>`总共 ${res.totalElements} 条`
            }
            this.selectedRowKeysId=[]
        })
    }

    /**
     * 重置
     * @returns {Promise<void>}
     */
    @action
    clearForm=async()=>{
        this.searchFields = {
            materialNo: '',
            sparePartName: '',
            sparePartNo: '',
            definitionFalg: ''
        }
        await this.initPage()
    }

    /**
     * 刪除
     */
    @action
    deleteSparepartDefination = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/defination/deleteById/id/${id}`)
        if (res && res.status >= 400) {
            return
        }
        runInAction(() => {
            message.success('删除成功')
            this.loading = false
        })
        await this.initPage()
    }

    /**
     * 显示新增修改
     */
    @action
    showAddAndModify = async(defination, record) => {
        if (defination === 'update') {
            let id = record.id
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/sparePart/getBySpareNo/id/${id}`)
            let sixPhotosList = res.sixPhotosList&&res.sixPhotosList.map((item,index)=> ({uid: index, url: item,}))
            this.forms = {
                ...this.forms,
                ...record,
                sixPhotosList:sixPhotosList||[]
            }
        }
        this.modal = true
    }


    /**
     * 显示新增属性维护
     */
    @action
    showAttributeEdit = async(record) => {
        this.attributeForms = record
        this.attributeModal = true
    }

    /**
     * 将表单时对象化，绑值给store。form
     */
    @action
    onFormsChange = (changedFields) => {
        this.forms={...this.forms,...ValueObjToObj(changedFields)}
    }

    /**
     * 将表单时对象化，绑值给store。form
     */
    @action
    onAttributeForms = (changedFields) => {
        this.attributeForms={...this.attributeForms,...ValueObjToObj(changedFields)}
    }

    /***新增、修改***/
    @action
    saveAddOrEditModal = async () => {
        this.loading = true
        let list = []
        Object.values(this.forms.sixPhotosList ? this.forms.sixPhotosList : '').map(item=>{
            if(item.response){
                return list.push(item.response)
            }else {
                return list.push(item.url)
            }
        })
        if (this.option === '新增') {
            let search = {
                spareNo: this.forms.spareNo ? this.forms.spareNo : '',
                materialNo: this.forms.materialNo ? this.forms.materialNo : '',
                spareName: this.forms.spareName ? this.forms.spareName : '',
                sixPhotosList: list,
            }
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/defination/add`, search)
            if (!res.status) {
                message.warning('备件编号已存在！')
                this.loading = false
                return
            }
            message.success("新增成功")
            runInAction(() => {
                this.loading = false
                this.modal = false
            })
        } else {
            let search = {
                id: this.forms.id.value ? this.forms.id.value : this.forms.id,
                spareNo: this.forms.spareNo.value ? this.forms.spareNo.value : this.forms.spareNo,
                materialNo: this.forms.materialNo.value ? this.forms.materialNo.value : this.forms.materialNo,
                spareName: this.forms.spareName.value ? this.forms.spareName.value : this.forms.spareName,
                sixPhotosList: list,
            }
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/defination/update`, search)
            if (!res.status) {
                message.warning('备件编号已存在！')
                this.loading = false
                return
            }
            message.success("修改成功")
            runInAction(() => {
                this.loading = false
                this.modal = false
            })
        }
        this.initPage(this.pagination.current)
    }

    /***属性维护我开始***/
    @action
    saveAttributeModal = async () => {
        this.loading = true
        let search = {
            id: this.attributeForms.id.value ? this.attributeForms.id.value : this.attributeForms.id,
            basicUnitOfMeasure: this.attributeForms.basicUnitOfMeasure.value ? this.attributeForms.basicUnitOfMeasure.value : this.attributeForms.basicUnitOfMeasure,
            weightNumber: this.attributeForms.weightNumber.value ? this.attributeForms.weightNumber.value : this.attributeForms.weightNumber,
            industryType: this.attributeForms.industryType.value ? this.attributeForms.industryType.value : this.attributeForms.industryType,
            netWeight: this.attributeForms.netWeight.value ? this.attributeForms.netWeight.value: this.attributeForms.netWeight,
            materialType: this.attributeForms.materialType.value ? this.attributeForms.materialType.value : this.attributeForms.materialType,
        }
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService//defination/newSparePartsAttributeAdded`, search)
        message.success(res.data)
        runInAction(() => {
            this.loading = false
        })
        this.initPage(this.pagination.current)
    }

    // /**
    //  * 生成备件编码
    //  * @returns {Promise<void>}
    //  */
    // @action
    // generatingSparePartsCoding=async ()=>{
    //     this.loading = true
    //     await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/defination/generateSparePartCode`,this.selectedRowKeysId)
    //     await this.initPage()
    //     runInAction(()=>{
    //         this.loading = false
    //     })
    // }

    /**
     * 同步英文
     * @param record
     * @returns {Promise<void>}
     */
    @action
    byEnglish = async ()=>{
        runInAction(() => {
            this.loading = true
        })
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/defination/synchronizeEnglish`)
        if(res.status){
            runInAction(() => {
                this.loading = false
                message.success(res.data)
            })
            this.initPage(this.pagination.current)
        }

    }


    /** 开启抽屉 **/
    @action
    onUpload = (arr) => {
        this.importReturnData = arr
        this.showDrawer = true
    }


    /** 关闭抽屉 **/
    @action
    onClose = () => {
        this.showDrawer = false
    }

}
export default new epcSparepartDefinationStore()



// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/EPC/EPCSparepartDefination/store.js